import React from 'react'

function Contact() {
    return (
        <div id='contact'>
            <h3>Contact US</h3>
            <div className="contact-input">
               
                <input type="text" placeholder="Enter your name"/>
                <a href="#">
                <input type="button" value="Submit"/>
                </a>
            </div>
        </div>
    )
}

export default Contact
